module.exports = __webpack_public_path__ + "img/home-about-big.54de345b.png";